import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./itemDetail.module.css";
import { useParams } from "react-router";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import QtyCounter from "../QtyCounter/QtyCounter";
import ProductNotFound from "../ProductNotFound/ProductNotFound";
import KeenSlider from "../ImgHome/KeenSlider/KeenSlider";

function ItemDetail() {
  const params = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const getProduct = async () => {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API_PORT}/products/${params.slug}`,
          method: "GET",
        });
        setProduct(response.data);
      } catch (error) {
        console.log(error.response.data.msg);
      }
    };
    getProduct();
  }, [params.slug]); // eslint-disable-line

  return (
    <>
      {product && product.stock > 0 && (
        <>
          <div className={styles.productBody + " container"}>
            <div className={styles.productCols + " row"}>
              <div
                className={
                  styles.productLeftCol + " col-12 col-lg-6 text-center"
                }
              >
                <img
                  src={product.pictures[0].img1}
                  className={styles.productPicture}
                  alt="Producto"
                />
              </div>
              <div className={styles.productRightCol + " col-12 col-lg-6 pe-3"}>
                <div className="d-flex justify-content-between">
                  <h1 className={styles.productName + " mb-3 fs-2"}>
                    {product.name}
                  </h1>
                  <div
                    className={
                      styles.nutriFeatures +
                      " d-flex justify-content-center align-item-center"
                    }
                  >
                    {" "}
                    {product.sugarfree ? (
                      <span className={styles.nutriIcon}>
                        <svg
                          fill="#9ca886"
                          version="1.1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 1000 1000"
                          enableBackground="new 0 0 1000 1000"
                        >
                          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                            <path d="M4622.6,5016.9c-693.8-70.9-1213.2-214.7-1782.4-494.5c-500.2-245.3-856.7-498.3-1263-891.2c-417.8-408.2-722.6-828-981.3-1353.1c-241.5-494.5-389.1-979.4-471.5-1552.4c-32.6-226.2-32.6-981.3,0-1207.5c136.1-950.6,504.1-1803.5,1082.9-2506.9c1353.1-1642.5,3595.5-2229,5571.5-1458.5C8043.7-3952.7,9071-2923.5,9569.3-1650.9C9772.5-1127.7,9876-625.6,9897-41c46,1326.3-446.6,2604.6-1374.2,3562.9c-421.7,435.1-833.7,736-1370.4,998.5c-483,237.7-927.6,377.6-1466.2,460C5492.8,5009.2,4789.4,5034.1,4622.6,5016.9z M5648,4520.5c674.6-105.4,1295.6-348.8,1839.9-720.6c185.9-126.5,479.1-358.4,479.1-377.6c0-7.7-249.2-264.5-555.8-569.2c-304.7-304.7-555.8-559.6-555.8-565.4c0-5.8,90.1-57.5,201.2-115l201.2-105.4l517.5,517.5l519.4,517.5l59.4-67.1c789.6-914.2,1178.7-2115.9,1067.5-3315.7C9228.2-2408,7526.2-4109.9,5398.8-4303.5c-1199.8-111.2-2401.5,277.9-3315.7,1067.5l-67.1,59.4l542.4,544.3l544.3,544.3l-191.7,118.8c-103.5,63.2-197.4,116.9-205.1,116.9c-7.7,0-233.8-224.2-502.1-498.3s-496.4-498.3-504.1-498.3c-23,0-245.3,281.7-381.4,479.2C473.2-1133.5,316.1,476.5,908.3,1862.2c329.7,774.3,889.3,1452.8,1596.5,1937.7c586.5,402.5,1318.6,668.9,2050.7,749.4C4785.5,4574.1,5408.4,4556.9,5648,4520.5z" />
                            <path d="M4862.2,2864.5c-69-23-2131.2-1148-2169.6-1184.4c-53.7-47.9-42.1-113.1,28.8-164.8c32.6-24.9,527.1-299,1096.3-609.5l1035-563.5h143.7h143.8l1035,563.5c569.2,310.5,1063.7,584.6,1098.2,609.5c69,51.7,80.5,116.9,28.8,164.8c-19.2,15.3-513.6,289.4-1098.2,607.6c-1015.8,553.9-1069.5,580.7-1178.7,586.5C4961.9,2877.9,4889,2874.1,4862.2,2864.5z" />
                            <path d="M2573.8,1030.4c-26.8-26.8-30.7-157.2-30.7-1153.8c0-1082.9,1.9-1125,38.3-1201.7c21.1-44.1,61.3-101.6,90.1-128.4c80.5-72.8,1924.2-1172.9,1981.7-1180.6c36.4-5.7,59.4,5.8,82.4,36.4c26.8,40.3,30.7,166.7,30.7,1215.1c0,1092.5-3.8,1174.9-36.4,1245.8c-19.2,42.2-57.5,99.7-86.2,128.4C4569,64.4,2715.6,1061,2654.3,1061C2625.6,1061,2589.2,1047.6,2573.8,1030.4z" />
                            <path d="M6376.3,570.4c-500.2-270.2-941-509.8-979.4-534.7c-44.1-28.8-90.1-84.3-120.7-145.7l-49.8-101.6v-1171c0-1048.4,3.8-1174.9,30.7-1215.1c23-30.7,46-42.1,82.4-36.4c57.5,7.7,1901.2,1107.8,1981.7,1180.6c28.8,26.8,69,84.3,90.1,128.4c36.4,76.7,38.3,118.8,38.3,1201.7c0,1061.8-1.9,1123.1-34.5,1151.9c-19.2,19.2-55.6,32.6-82.4,32.6C7307.7,1061,6876.5,840.6,6376.3,570.4z" />
                          </g>
                        </svg>
                        <p>Sin Azucar</p>
                      </span>
                    ) : (
                      <></>
                    )}
                    {product.glutenfree ? (
                      <span className={styles.nutriIcon}>
                        <svg
                          fill="#9ca886"
                          version="1.1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 1000 1000"
                          enableBackground="new 0 0 1000 1000"
                        >
                          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                            <path d="M4622.6,5016.9c-693.8-70.9-1213.2-214.7-1782.4-494.5c-500.2-245.3-856.7-498.3-1263-891.2c-417.8-408.2-722.6-828-981.3-1353.1c-241.5-494.5-389.1-979.4-471.5-1552.4c-32.6-226.2-32.6-981.3,0-1207.5c136.1-950.6,504.1-1803.5,1082.9-2506.9c1353.1-1642.5,3595.5-2229,5571.5-1458.5C8043.7-3952.7,9071-2923.5,9569.3-1650.9C9772.5-1127.7,9876-625.6,9897-41c46,1326.3-446.6,2604.6-1374.2,3562.9c-421.7,435.1-833.7,736-1370.4,998.5c-483,237.7-927.6,377.6-1466.2,460C5492.8,5009.2,4789.4,5034.1,4622.6,5016.9z M5648,4520.5c845.2-132.2,1623.3-490.6,2261.6-1040.7l67.1-59.4l-659.3-661.2L6658,2099.8l74.7-13.4c40.3-7.7,155.3-34.5,253-61.3l180.2-49.8l563.5,563.5l565.4,563.5l59.4-67.1c789.6-914.2,1178.7-2115.9,1067.5-3315.7C9228.2-2408,7526.2-4109.9,5398.8-4303.5c-1199.8-111.2-2401.5,277.9-3315.7,1067.5l-67.1,59.4l484.9,486.8l484.9,486.8l-28.8,116.9c-17.3,63.3-36.4,170.6-42.2,237.7s-15.3,134.2-19.2,147.6c-5.7,19.2-220.4-180.2-603.7-565.4l-594.1-592.2l-59.4,67.1C739.7-1750.6,371.7-363,638.1,984.4c224.2,1142.3,891.2,2146.6,1866.7,2815.4c586.5,402.5,1318.6,668.9,2050.7,749.4C4785.5,4574.1,5408.4,4556.9,5648,4520.5z" />
                            <path d="M4913.9,3705.9c-187.8-170.6-368-463.8-454.2-737.9c-59.4-189.7-74.7-555.8-28.7-778.1c40.3-205.1,118.8-392.9,239.6-576.9c95.8-145.7,291.3-360.3,327.7-360.3c32.6,0,218.5,199.3,300.9,322c210.8,310.5,293.3,573.1,293.3,946.8c0,429.3-157.2,810.7-467.7,1138.4l-122.7,128.4L4913.9,3705.9z" />
                            <path d="M3424.8,1797c-26.8-3.8-84.3-13.4-128.4-19.2c-101.6-11.5-111.2-46-82.4-293.2c51.8-458.1,268.3-810.7,651.6-1069.5C4120.5,244.6,4385,127.7,4707,45.2c256.8-65.2,239.6-80.5,226.2,207c-21.1,410.2-115,753.2-270.2,987c-161,241.5-465.7,450.4-759,517.5C3771.7,1787.4,3505.3,1810.4,3424.8,1797z" />
                            <path d="M6255.6,1789.3c-277.9-34.5-544.3-155.2-739.8-337.3C5234,1191.4,5088.3,810,5059.6,252.2c-13.4-287.5-30.7-272.2,226.2-207c743.6,189.8,1247.7,584.6,1424,1113.5c53.7,159.1,93.9,458.1,76.7,550c-9.6,49.8-23,59.4-82.4,69C6554.5,1800.8,6380.1,1804.7,6255.6,1789.3z" />
                            <path d="M3294.4,146.8c-93.9-11.5-109.2-61.3-82.4-279.8c57.5-490.6,260.6-822.2,670.8-1096.3c203.1-136.1,391-226.1,624.8-302.8c174.4-57.5,406.3-109.2,421.6-93.9c15.3,17.3,11.5,249.2-9.6,435.1c-42.2,368-178.2,724.5-354.6,923.8c-168.7,191.7-437,339.2-722.6,398.7C3719.9,158.3,3445.9,164.1,3294.4,146.8z" />
                            <path d="M6136.7,133.4C5511.9-12.3,5165-439.6,5075-1171.8c-21.1-180.1-28.8-437-11.5-454.2c32.6-30.7,473.4,97.8,716.8,207c222.3,101.6,498.3,297.1,642.1,450.4c147.6,161,260.6,371.8,318.1,599.9c46,182.1,59.4,458,23,494.5C6729,160.2,6282.4,166,6136.7,133.4z" />
                            <path d="M3325.1-1486.1c-49.8-7.7-97.7-19.2-105.4-28.8c-26.8-26.8-7.7-318.2,32.6-483c59.4-253,210.8-523.2,379.5-674.6c289.4-260.7,659.3-452.3,1067.5-552c105.4-24.9,203.2-46,218.5-46c23,0,24.9,42.2,15.3,245.3c-28.8,536.6-162.9,912.3-419.7,1169.1C4222.1-1562.8,3773.6-1424.8,3325.1-1486.1z" />
                            <path d="M6175.1-1495.7c-266.4-49.8-519.4-182.1-697.6-358.4c-254.9-256.8-392.9-640.1-417.8-1171c-9.6-210.8-7.7-245.3,17.3-245.3c65.2,0,431.2,103.5,586.5,164.8c364.1,145.7,703.4,392.9,864.4,626.7c141.8,208.9,216.6,415.9,253,705.3c21.1,174.4,11.5,256.8-34.5,274.1C6677.2-1472.7,6305.4-1470.8,6175.1-1495.7z" />
                          </g>
                        </svg>
                        <p>Sin Gluten</p>
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <h2 className={styles.productPrice + " mb-3"}>
                  $ {product.price}
                </h2>
                <div>
                  <AiFillStar className={styles.filledStar} />
                  <AiFillStar className={styles.filledStar} />
                  <AiFillStar className={styles.filledStar} />
                  <AiFillStar className={styles.filledStar} />
                  <AiOutlineStar className={styles.emptyStar} />
                </div>
                <p className={styles.stockP}>Stock: {product.stock}</p>
                <div className="mt-3 mb-auto">
                  <p className={styles.productDescription}>
                    {product.description}
                  </p>
                </div>
                <div className="d-flex align-items-end ">
                  <QtyCounter product={product} />
                </div>
              </div>
              <h4 className="mt-5 pt-5 mb-4 text-center">
                Probá nuestros productos destacados
              </h4>
              <KeenSlider />
            </div>
          </div>
        </>
      )}{" "}
      {product && product.stock === 0 && <ProductNotFound />}
    </>
  );
}

export default ItemDetail;
